export default __webpack_public_path__ + "static/media/ScriptKiddie_HTB.713b2b6b.md";